import axios from "axios";
import {
  APIUSEROLD,
  API_FAILURE,
  GET_NEW_REQUEST_HISTORY,
  GET_NEW_REQUEST_HISTORY_EXPORT,
} from "../../../../config/constants";
import { apiErrors } from "../../../../helper";
import axiosHelper from "../../../../axiosHelper";
export function fetchUsers(filter) {
  return async (dispatch) => {
    try {
      const response = await axiosHelper.get(
        `${filter?.isDelegated ? APIUSEROLD.getNewSupplierRequestHistoryDelegated : APIUSEROLD.getNewSupplierRequestHistory}`,
        {
          params: {
            EmployeeId: filter?.EmployeeId,
            page: filter.current_page,
            pageSize: filter.per_page,
            RequestNo: filter.SupplierRepositoryRequestNo,
            SupplierName: filter.SupplierName,
            EmailAddress: filter.EmailAddress,
            SupplierSpecialization: filter.SupplierSpecialization,
            BusinessType: filter.BusinessType,
            ContactNo: filter.ContactNumber,
            SortBy: filter?.sortField,
            SortOrder: filter.sortOrder,
            RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
            RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
            isDelegated: filter?.isDelegated ? true : false,
          },
        }
      );

      if (response?.data || response.status === 204) {
        dispatch({
          type: GET_NEW_REQUEST_HISTORY,
          payload: {
            data: response.status === 204 ? [] : response?.data?.Result,
            filter,
          },
        });
        return response?.data?.Result;  // Return data for further processing
      }
    } catch (error) {
      dispatch({ type: API_FAILURE });
      apiErrors(error);
      // throw error;  // Throw error to be caught in getUsers
    }
  };
}


export function fetchExport(filter, callback) {
  
  return (dispatch) => {
    const request = axiosHelper.get(
      `${APIUSEROLD.getNewRequestHistoryExport}`,
      {
        params: {
          EmployeeId: filter?.EmployeeId,
          page: filter.current_page,
          pageSize: filter.per_page,
          RequestNo: filter.SupplierRepositoryRequestNo,
          SupplierName: filter.SupplierName,
          EmailAddress: filter.EmailAddress,
          SupplierSpecialization: filter.SupplierSpecialization,
          BusinessType: filter.BusinessType,
          ContactNo: filter.ContactNumber,
          SortBy: filter?.sortField,
          SortOrder: filter.sortOrder,
          RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
          RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
          // RequestToDate: filter.requestToDate ||filter?.requestFromDate,
        }, // Assuming filter contains necessary query parameters
      }
    );
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_NEW_REQUEST_HISTORY_EXPORT,
            payload: {
              data: response.status === 204 ? [] : response?.data,

              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        // callback(null, error);
        if (error.response.status === 401) {
          apiErrors(error)
        }
      });
  };
}

export function fetchExportApproveHistory(filter, callback) {
  
  return (dispatch) => {
    const request = axiosHelper.get(
      `${APIUSEROLD.getApproveRequestHistoryExport}`,
      {
        params: {
          EmployeeId: filter?.EmployeeId,
          page: filter.current_page,
          pageSize: filter.per_page,
          RequestNo: filter.SupplierRepositoryRequestNo,
          SupplierName: filter.SupplierName,
          EmailAddress: filter.EmailAddress,
          SupplierSpecialization: filter.SupplierSpecialization,
          BusinessType: filter.BusinessType,
          ContactNo: filter.ContactNumber,
          SortBy: filter?.sortField,
          SortOrder: filter.sortOrder,
          RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
          RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
          // RequestToDate: filter.requestToDate ||filter?.requestFromDate,
        }, // Assuming filter contains necessary query parameters
      }
    );
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_NEW_REQUEST_HISTORY_EXPORT,
            payload: {
              data: response.status === 204 ? [] : response?.data,

              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }
        // callback(null, error);
        // apiErrors(error);
      });
  };
}
export function fetchSupplierNeedListExport(filter, callback) {
  
  
  return (dispatch) => {
    const request = axiosHelper.get(
      `${APIUSEROLD.getVendorNeedListExport}`,
      {
        params: {
          employeeId: filter?.EmployeeId,
          applicationNo: filter?.ApplicationNo,
          vendorCode: filter?.VendorCode,
          supplierCategory: filter?.CategoryName,
          requestStatus: filter?.Status,
          plant: filter?.PlantName,
          supplierName: filter?.SupplierName,
          SearchText: filter?.sortField?.supplierName,
          requestedBy: filter?.RequestedBy,
          SortBy: filter?.sortField,
          SortOrder: filter.sortOrder,
          RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
          RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
          // RequestToDate: filter.requestToDate ||filter?.requestFromDate,
        }, // Assuming filter contains necessary query parameters
      }
    );
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_NEW_REQUEST_HISTORY_EXPORT,
            payload: {
              data: response.status === 204 ? [] : response?.data,

              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        // callback(null, error);
        if (error.response.status === 401) {
          apiErrors(error)
        }
      });
  };
}


export function fetchBlockedSupplierExport(filter, callback) {
  
  
  return (dispatch) => {
    const request = axiosHelper.get(
      `${APIUSEROLD.getUnblockExport}`,
      {
        params: {
          employeeId: filter?.EmployeeId,
          applicationNo: filter?.ApplicationNo,
          vendorCode: filter?.VendorCode,
          supplierCategory: filter?.CategoryName,
          requestStatus: filter?.Status,
          plant: filter?.PlantName,
          supplierName: filter?.SupplierName,
          SearchText: filter?.sortField?.supplierName,
          requestedBy: filter?.RequestedBy,
          SortBy: filter?.sortField,
          SortOrder: filter.sortOrder,
          RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
          RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
          // RequestToDate: filter.requestToDate ||filter?.requestFromDate,
        }, // Assuming filter contains necessary query parameters
      }
    );
    request
      .then((response) => {
        
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_NEW_REQUEST_HISTORY_EXPORT,
            payload: {
              data: response.status === 204 ? [] : response?.data,

              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        // callback(null, error);
        if (error.response.status === 401) {
          apiErrors(error)
        }
      });
  };
}
// export const fetchExport = async (filter) => {
//   
//   try {
//     const response = await axiosHelper.get(`${APIUSEROLD.getNewRequestHistoryExport}`, {
//       params: {
//         EmployeeId: filter?.EmployeeId,
//         RequestToDate: filter.CreatedOn,
//         RequestNo: filter.SupplierRepositoryRequestNo,
//         SupplierName: filter.SupplierName,
//         EmailAddress: filter.EmailAddress,
//         SupplierSpecialization: filter.SupplierSpecialization,
//         BusinessType: filter.BusinessType,
//         ContactNo: filter.ContactNumber,
//         SortBy: filter?.sortField,
//         SortOrder: filter.sortOrder,
//         RequestFromDate: filter.requestFromDate,
//         // RequestToDate: filter.requestToDate || filter?.requestFromDate,
//       }, // Assuming filter contains necessary query parameters
//     });
// 
//     if (response?.data || response.status === 204) {
//       return {
//         data: response.status === 204 ? [] : response?.data,
//         filter, // Include filter in return data if needed
//       };
//     }
//   } catch (error) {
//     
//     throw error;
//   }
// };

export const updatStatusAcceptFunctionaliy = async (reqData) => {
  try {
    const response = await axiosHelper.post(
      `${APIUSEROLD.postAcceptRequestByEmployee}`,
      reqData
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error("Failed to update user");
    }
  } catch (error) {
    
    throw error;
  }
};

export function getViewDetailsNewReuestHistory(id) {
  const request = axiosHelper.get(
    `${APIUSEROLD.getViewNewRequestHistory}/${id}`
  ); // Include the id in the URL
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      }
      throw error; // Re-throw the error to the caller
    });
}
export async function clickCheckRiskCountService(reqData) {
  try {
    const response = await axiosHelper.post(`${APIUSEROLD.checkAllRiskCount}`, {
      supplierRepositoryRequestGuid: reqData,
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error("Failed to update user");
    }
  } catch (error) {
    
    throw error;
  }
}
